import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "pages/Home/index";
import ErrorPage from "pages/Error/index";
import SPCRegistration from "pages/SPC/index";

const MainRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Rupay */}
        <Route path="/rupay/authenticate/:token" element={<Home />} />
        <Route path="/rupay/error" element={<ErrorPage />} />

        {/* Mastercard */}
        <Route path="/mastercard/authenticate/:token" element={<Home />} />
        <Route path="/mastercard/error" element={<ErrorPage />} />

        {/* Visa */}
        <Route path="/visa/authenticate/:token" element={<Home />} />
        <Route path="/visa/error" element={<ErrorPage />} />

        {/* SPC */}
        <Route path="/spc/register" element={<SPCRegistration />} />
        <Route path="/spc/error" element={<ErrorPage />} />

        {/* Fallback */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
};

export default MainRoutes;
